<template>
  <div
    v-if="item"
    :id="`inner-chat-${item.id}-${mode}`"
    class="inner-chat-card"
    :class="{'is-my': isMine, 'not-read': !item.isViewed, 'mode-modal': mode==='modal'}"
    data-qa="inner-chat-card"
    :index="index"
    :message-key="item.id">
    <div
      class="inner-chat-card_header"
      data-qa="inner-chat-card-header">
      <div class="inner-chat-card_header-user">
        <UserIcon
          :border="false"
          :name="item.userLogin"
          size="32"/>
      </div>
      <div class="inner-chat-card_header-info">
        <div
          class="inner-chat-card_userLogin"
          data-qa="inner-chat-card-login">
          {{ item.userLogin }}
        </div>
        <div
          class="inner-chat-card_time"
          data-qa="inner-chat-card-data">
          {{ $d(new Date(item.timestamp), "shortDate") }}, {{ $d(new Date(item.timestamp), "time") }}
        </div>
      </div>
    </div>
    <div
      v-if="item.message || item.parentMessage"
      class="inner-chat-card_message">
      <InnerChatMessage
        v-if="item && item.parentMessageId"
        class="inner-chat-card_message-parent"
        data-qa="inner-chat-card-message-parent"
        :value="item.parentMessage"
        @click.stop="$emit('scrollToParrent', item.parentMessageId)"/>
      <div class="inner-chat-card_message-item">
        <InnerChatMessage
          data-qa="inner-chat-card-message"
          :value="item"/>
        <sButton
          v-if="!item.isMine"
          class="inner-chat-card_message-btn-answer"
          data-qa="inner-chat-card-answer"
          icon="arrow-answer"
          small
          type="text"
          @click="$emit('answer', item)"/>
      </div>
      <div
        :class="`inner-chat-card_message-is-viewed ${item.isViewed ? 'true' : 'false'}`"
        @click="changeViewed"/>
    </div>
    <InnerChatAttachment
      v-for="(attachment) in item.attachments"
      :key="`inner-chat-attachment-${attachment.id}`"
      :attachment="attachment"
      data-qa="inner-chat-card-attachments"
      :mode="isMine ? 'right' : 'left'"/>
  </div>
</template>
<script>
import UserIcon from 'components/header/UserIcon.vue'
import InnerChatMessage from 'components/common/blocks/inner-chat/InnerChatMessage.vue'
import InnerChatAttachment from 'components/common/blocks/inner-chat/InnerChatAttachments.vue'

export default {
  name: 'innerChatCard',
  methods: {
    changeViewed() {
      if (!this.item.isViewed) {
        this.$emit('changeViewed', this.item)
      }
    },
  },
  computed: {
    user() {
      return this.$store.getters['GET_USER']
    },
    isMine() {
      if (!this.item) {
        return false
      }
      return this.item.userLogin.toLowerCase() === this.user.login.toLowerCase()
    }
  },
  props: {
    item: {
      type: Object,
      require: true
    },
    index: {
      type: [String, Number],
    },
    dataQa: {
      type: String,
      default: 'inner-chat-card'
    },
    mode: {
      type: String,
      default: 'small'
    }
  },
  components: {
    UserIcon,
    InnerChatMessage,
    InnerChatAttachment
  }
}
</script>
<style lang="scss">
.inner-chat-card_tag {
  font-weight: bold;
  &-0 {
    font-weight: 600;
    text-decoration: underline;
  }
  &-1 {
    text-decoration: underline;
  }
  &-2 {
    text-decoration: underline;
  }
}
</style>
<style scoped lang="scss">
.inner-chat-card {
  margin: 10px auto 0;
  text-align: left;
  max-width: 830px;
  width: 100%;
  border-radius: 20px 5px 18px 18px;
  &_header {
    display: flex;
  }
  &_userLogin {
    padding-left: 8px;
    color: var(--black-color);
    font-size: 14px;
    line-height: 18px;
  }
  &_time {
    padding-left: 8px;
    color: var(--black-color);
    opacity: 0.5;
    font-size: 12px;
    line-height: 16px;
  }
  &_tag {
    font-weight: bold;
    &-0 {
      color: blue;
    }
    &-1 {
      color: red;
    }
    &-2 {
      color: green;
    }
  }
  &_message {
    position: relative;
    margin-top: 8px;
    margin-left: 15px;
    padding: 14px;
    color: var(--black-color);
    background: var(--green_chosen_light);
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    border-radius: 0 15px 15px 15px;
    &:hover,
    &:focus {
      .inner-chat-card_message-btn-answer {
        opacity: 1;
      }
    }
    &-item {
      align-self: flex-start;
      display: flex;
      justify-content: space-between;
      white-space: pre-line;
    }
    &-parent {
      border-left: 2px solid #080808;
      cursor: pointer;
      padding-left: 6px;
      color: #828e8d;
      font-size: 12px;
      line-height: 16px;
      margin-bottom: 10px;
    }
    &-btn-answer {
      opacity: 0;
      transition: 0.25s all;
      align-self: flex-end;
    }
    &-is-viewed {
      position: absolute;
      right: 0;
      top: 0;
      width: 14px;
      height: 14px;
      z-index: 1;
      cursor: pointer;
      &::after {
        content: "✓";
      }
      &.true {
        cursor: default;
      }
      &.true::after {
        color: var(--color-main-green);
      }
      &.true::before {
        content: "✓";
        color: var(--color-main-green);
        top: 1px;
        right: 5px;
        position: absolute;
      }
      &.false::after {
        color: grey;
      }
    }
  }
}

.inner-chat-card.mode-modal {
  .inner-chat-card_message {
    margin-left: 0px;
  }
}

.inner-chat-card.is-my {
  border-radius: 5px 20px 18px 18px;
  &.mode-modal {
    .inner-chat-card_message {
      margin-right: 0px;
    }
  }
  .inner-chat-card {
    &_userLogin {
      padding-left: 0px;
      padding-right: 8px;
    }
    &_time {
      padding-left: 0px;
      padding-right: 8px;
    }
  }
  .inner-chat-card_header {
    justify-content: flex-end;
    &-user {
      order: 2;
    }
    &-info {
      order: 1;
    }
  }
  .inner-chat-card_message {
    margin-left: 0px;
    margin-right: 15px;
    border-radius: 15px 0 15px 15px;
    background: var(--color-main-green);
    overflow: hidden;
    &-is-viewed {
      &.true::after {
        color: var(--green_chosen_light);
      }
      &.true::before {
        color: var(--green_chosen_light);
      }
    }
  }
}
</style>
